module.exports = __webpack_public_path__ + "img/github-3.61df7561.jpg";